import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    organization: "",  
    users:[],
    camp:{},
    feature: {
      dashBoard: "default",
      patientAdd: "default",
      patientView: "default",
      patientEdit:"default",
      patientVisitEdit:"default",
      patientVisitAdd:"default",
      patientVisitView:"default",
      logisticsView:"default",
      logisticsIncomArrived: "default",
      logisticsIncomMissed: "default",
      logisticsArrived: "default",
      logisticsMissed: "default",
      logisticsMissedSchedule:"default",
      invoicesView: "default",
      invoicesAdd: "default",
      invoicesEdit: "default",
      paymentAdd: "default",
      reportsView:"default",
      settingsView: "default",
      userView: "default",
      userAdd:"default",
      userEdit: "default",
      userAddRole: "default",
      campView: "default",
      campAdd: "default",
      campEdit: "default",
      organization:"default",
      organizationAdd: "default",
      organizationEdit: "default",
      customFieldControl: "default",
      rolesView: "default",
      rolesAdd: "default",
      rolesEdit: "default",
      permissionList: "default",
      basicView: "default",
    },
  },
  reducers: {
    updateMenu(state, action) {
      state.selectedMenu = action.payload;
    },
    userProfile(state, action) {
      state.user = action.payload;
    },
    updateOrganization(state, action) {
      state.organization = action.payload;
    },
    updateCamp(state, action) {
      state.camp = action.payload;
    },
  },
});

export const { updateMenu, userProfile, updateOrganization, updateCamp } =
  commonSlice.actions;

export default commonSlice.reducer;
